import { Person } from "../../tables/general/person";
import { Plan } from "../../tables/accreditation/plan";
import { Insurance } from "../../accreditation/insurance";
import { Moment } from "moment";
import {
    OrderAuthorization,
    Procedure,
} from "../../backend-definitions.module";

export class Patient {
    id: number;
    parent: Patient;
    active: boolean;
    pcd: boolean;
    medicalRecord: number;
    person: Person;
    insurance: Insurance;
    plan: Plan;
    enrollment: string;
    validity: Moment;
    dated: Moment;
    holder: string;
    product: string;
    userCreated: string;
}

export class PatientSimple {
    id: string;
    name: string;
    medicalRecord: string;
    status: string;
    cpf: string;
    insuranceName: string;
    enrolment: string;
    enrolmentDate: string;
    birthday: Moment;
}

export class AuthorizationModel {
    id: string;
    patient: Patient;
    insurance: Insurance;
    procedure: Procedure;
    quantity: string;
    active: boolean = true;
    orderAuthorization?: OrderAuthorization;
    valueLauncher?: number;
}

export class ModelAuthorization {
    authorizationModel: AuthorizationModel;
    orderAuthorization: OrderAuthorization;
}

export class PatientCareInsert {
    patient_id: number;
    performer_id: number;
    speciality_id: number;
    active: boolean = true;
}

export class PatientTO {
    id: number;
    personId: number;
    parameterValueId: number;
    patient_care_id: number;
    patient_care_active: boolean;
    patient_care_speciality: string;
    name: string;
    socialName: string;
    medicalRecord: string;
    gender: string;
    civilStatus: string;
    status: string;
    active: boolean;
    cpf: string;
    insuranceId: number;
    insuranceName: string;
    enrolment: string;
    phoneStandart: string;
    email: string;
    rg: string;
    cns: string;
    mother: string;
    delete: boolean;
    address: string;
    cep: string;
    district: string;
    number: string;
}
